import {
    compressImage, filter, getDateFormats, getIcons, getTimeFormats, isValidEmail
} from "../utils";
import FileServer from "../singleton/file-server";

export default {

    getDateFormats,

    getTimeFormats,

    compressImage,

    isValidEmail,

    getIcons,

    filter,

    getFileUrl: FileServer.getFileUrl.bind(FileServer)

}